import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgBook = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="M.005 4.553A1.21 1.21 0 0 0 0 4.688v16.126a1.192 1.192 0 0 0 .212.699 1.138 1.138 0 0 0 .8.48 1.093 1.093 0 0 0 .702-.159A9.518 9.518 0 0 1 6.566 20.5c1.703 0 3.376.46 4.853 1.334a1.101 1.101 0 0 0 1.163 0 9.518 9.518 0 0 1 4.852-1.334c1.703 0 3.376.46 4.852 1.334a1.11 1.11 0 0 0 .703.16 1.137 1.137 0 0 0 .803-.486 1.177 1.177 0 0 0 .208-.695V4.688a1.212 1.212 0 0 0-.151-.605 1.148 1.148 0 0 0-.435-.44A11.732 11.732 0 0 0 17.434 2C15.542 2 13.68 2.46 12 3.34A11.717 11.717 0 0 0 6.566 2c-2.098 0-4.16.567-5.98 1.644a1.13 1.13 0 0 0-.432.434c-.08.142-.133.303-.149.475Zm21.73.81a9.504 9.504 0 0 0-4.301-1.031 9.503 9.503 0 0 0-4.302 1.032V18.99a11.691 11.691 0 0 1 8.604 0V5.364Zm-10.867 0V18.99a11.692 11.692 0 0 0-8.604 0V5.364a9.504 9.504 0 0 1 4.302-1.032 9.5 9.5 0 0 1 4.302 1.032Z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgBook);
export default ForwardRef;
